/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const L4AclsEnum = {
    GET_HAPROXY_ACL: (id: string): string => {
        return '/ipvsDirector/acls/' + id;
    },
    GET_HAPROXY_ACLS: '/ipvsDirector/acls',
    POST_HAPROXY_ACL: '/ipvsDirector/acls',
    PUT_HAPROXY_ACL: (id: string): string => {
        return '/ipvsDirector/acls/' + id;
    },
    DELETE_HAPROXY_ACL: (id: string): string => {
        return '/ipvsDirector/acls/' + id;
    },
    GET_HAPROXY_HANGING_ACLS: (): string => {
        return '/ipvsDirector/acls/hanging';
    }
};
